export const Env = {
    ...{
        production: false,
        baseUrl: "https://backoffice-dev-api.mahfza.com/api/",
    }, // any custom env config here
    // --------------------------------------------------------------------
    // base env config here (this imported as separate JS script in Angular.Json as separated script)
    ... (window as any).bootstrapConfigSettings
}